<template>
  <div ref="contasLocalidadeChart" @update-charts="update" />
</template>

<script>
import ApexCharts from 'apexcharts';
import { i18n } from '@/modules/localization/index.js';
import eventbus from '@/modules/core/services/eventbus';
import estatisticasChartsDefaultOptions from './estatisticasChartsDefaultOptions';
export default {
  props: {
    loading: { type: Boolean, required: true },
  },
  data: () => ({
    contasLocalidadeChart: null,
    options: estatisticasChartsDefaultOptions,
  }),
  mounted() {
    this.contasLocalidadeChart = new ApexCharts(this.$refs.contasLocalidadeChart, this.options);
    this.contasLocalidadeChart.render();
    eventbus.on('update-charts', this.update);
  },
  unmounted() {
    this.contasLocalidadeChart.destroy();
    eventbus.off('update-charts', this.update);
  },
  methods: {
    async update(chartsData) {
      const dados = chartsData.contasLocalidade.map((p) => ({ x: p.localidade, y: p.quantidade }));
      this.contasLocalidadeChart.updateOptions({
        chart: {
          height: 500,
          type: 'treemap',
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '14px',
          },
          formatter: function(text, op) {
            return [text, op.value];
          },
          offsetY: -4,
        },
        plotOptions: {
          treemap: {
            enableShades: true,
            reverseNegativeShade: true,
          },
        },
        legend: {
          show: false,
        },
        title: {
          text: i18n.global.t('contasLocalidade'),
        },
        series: [{ data: dados }],
      });
    },
  },
};
</script>
